export const albums = [
  {
    albumId: 'album-1',
    title: 'Midnight Memories',
    description: 'A collection of songs inspired by late night thoughts and dreams.',
    coverArtUrl: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    songs: ['song-1', 'song-2', 'song-3'],
    songOrder: ['song-1', 'song-2', 'song-3'],
    createdAt: '2023-01-15T12:00:00Z',
    updatedAt: '2023-02-20T15:30:00Z'
  },
  {
    albumId: 'album-2',
    title: 'Summer Vibes',
    description: 'Upbeat songs for sunny days and warm nights.',
    coverArtUrl: 'https://images.unsplash.com/photo-1534854638093-bada1813ca19?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    songs: ['song-4', 'song-5'],
    songOrder: ['song-4', 'song-5'],
    createdAt: '2023-03-10T09:15:00Z',
    updatedAt: '2023-04-05T11:45:00Z'
  },
  {
    albumId: 'album-3',
    title: 'Acoustic Sessions',
    description: 'Stripped down versions of favorite songs.',
    coverArtUrl: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    songs: ['song-6', 'song-7', 'song-8'],
    songOrder: ['song-6', 'song-7', 'song-8'],
    createdAt: '2023-05-22T14:20:00Z',
    updatedAt: '2023-06-18T16:10:00Z'
  }
];

export const moodboards = [
  {
    moodboardId: 'moodboard-1',
    title: 'Night Sky Inspirations',
    description: 'Visual elements for the Midnight Memories album',
    coverImageUrl: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    associationType: 'album',
    associationId: 'album-1',
    items: [
      {
        itemId: 'item-1',
        type: 'image',
        title: 'Starry Night',
        imageUrl: 'https://images.unsplash.com/photo-1528722828814-77b9b83aafb2?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
        tags: ['stars', 'night', 'inspiration']
      },
      {
        itemId: 'item-2',
        type: 'image',
        title: 'Northern Lights',
        imageUrl: 'https://images.unsplash.com/photo-1483086431886-3590a88317fe?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
        tags: ['aurora', 'sky', 'colors']
      },
      {
        itemId: 'item-3',
        type: 'text',
        title: 'Lyric Ideas',
        textContent: 'Dancing under the moonlight, stars as our spotlight, guiding us through the night',
        tags: ['lyrics', 'ideas']
      },
      {
        itemId: 'item-4',
        type: 'link',
        title: 'Night Sky Photography',
        linkUrl: 'https://www.nationalgeographic.com/photography/article/night-sky-photography-tips',
        tags: ['reference', 'photography']
      }
    ],
    itemOrder: ['item-1', 'item-2', 'item-3', 'item-4'],
    tags: ['night', 'stars', 'album-inspiration'],
    createdAt: '2023-01-10T08:30:00Z',
    updatedAt: '2023-01-20T14:45:00Z'
  },
  {
    moodboardId: 'moodboard-2',
    title: 'Summer Aesthetic',
    description: 'Beach vibes and summer feelings for the Summer Vibes album',
    coverImageUrl: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    associationType: 'album',
    associationId: 'album-2',
    items: [
      {
        itemId: 'item-5',
        type: 'image',
        title: 'Sunset Beach',
        imageUrl: 'https://images.unsplash.com/photo-1414609245224-afa02bfb3fda?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
        tags: ['sunset', 'beach', 'ocean']
      },
      {
        itemId: 'item-6',
        type: 'image',
        title: 'Palm Trees',
        imageUrl: 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
        tags: ['tropical', 'summer', 'palm']
      },
      {
        itemId: 'item-7',
        type: 'link',
        title: 'Summer Playlist',
        linkUrl: 'https://open.spotify.com/playlist/37i9dQZF1DX3ZeFHRhhi7Y',
        tags: ['music', 'playlist', 'reference']
      }
    ],
    itemOrder: ['item-5', 'item-6', 'item-7'],
    tags: ['summer', 'beach', 'warm'],
    createdAt: '2023-03-05T11:20:00Z',
    updatedAt: '2023-03-15T09:10:00Z'
  },
  {
    moodboardId: 'moodboard-3',
    title: 'Acoustic Vibes',
    description: 'Inspiration for the acoustic album',
    associatedAlbumId: 'album-3',
    items: [
      {
        itemId: 'item-8',
        type: 'image',
        title: 'Vintage Guitar',
        imageUrl: 'https://images.unsplash.com/photo-1525201548942-d8732f6617a0?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
        tags: ['guitar', 'instrument', 'vintage']
      },
      {
        itemId: 'item-9',
        type: 'image',
        title: 'Recording Studio',
        imageUrl: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
        tags: ['studio', 'recording', 'equipment']
      },
      {
        itemId: 'item-10',
        type: 'text',
        title: 'Production Notes',
        textContent: 'Keep it minimal. Focus on vocal clarity and guitar dynamics. Use room mics for natural reverb.',
        tags: ['production', 'notes']
      }
    ],
    itemOrder: ['item-8', 'item-9', 'item-10'],
    tags: ['acoustic', 'minimal', 'organic'],
    createdAt: '2023-05-18T13:40:00Z',
    updatedAt: '2023-05-25T16:30:00Z'
  },
  {
    moodboardId: 'moodboard-3',
    title: 'Starlight Visuals',
    description: 'Visual inspiration for the Starlight song',
    coverImageUrl: 'https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    associationType: 'song',
    associationId: 'song-1',
    items: [
      {
        itemId: 'item-13',
        type: 'image',
        title: 'Milky Way',
        imageUrl: 'https://images.unsplash.com/photo-1532721344391-eaf75d3ab37f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
        tags: ['stars', 'galaxy', 'night']
      },
      {
        itemId: 'item-14',
        type: 'image',
        title: 'Shooting Star',
        imageUrl: 'https://images.unsplash.com/photo-1596558450268-9c27524ba856?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
        tags: ['meteor', 'night', 'wish']
      },
      {
        itemId: 'item-15',
        type: 'text',
        title: 'Visual Concepts',
        textContent: 'Glowing stars that fade in and out, silhouettes of people looking up at the night sky, time-lapse of stars moving across the sky',
        tags: ['concepts', 'visuals', 'ideas']
      }
    ],
    itemOrder: ['item-13', 'item-14', 'item-15'],
    tags: ['stars', 'night', 'song-inspiration'],
    createdAt: '2023-03-10T09:15:00Z',
    updatedAt: '2023-03-15T11:45:00Z'
  }
];

export const songs = [
  {
    songId: 'song-1',
    title: 'Starlight',
    lyrics: "Verse 1:\nBeneath the starlight\nWe found our way home\nThrough the darkness\nWe were never alone\n\nChorus:\nStarlight, guide me through\nStarlight, I'll follow you\nThrough the night, till the morning comes\nUnder the starlight, we become\n\nVerse 2:\nMemories flicker\nLike stars in the sky\nHolding on to moments\nThat never say goodbye",
    notes: 'Written during a camping trip. The melody came first, inspired by the quiet of the forest at night.',
    inspirations: 'Night sky, camping, feeling of peace in nature',
    coverArtUrl: 'https://images.unsplash.com/photo-1539593395743-7da5ee4a01d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    versions: [
      {
        versionId: 'v1-song-1',
        versionName: 'Acoustic Demo',
        audioUrl: 'https://example.com/audio/starlight-demo.mp3',
        createdAt: '2023-01-10T10:00:00Z'
      },
      {
        versionId: 'v2-song-1',
        versionName: 'Full Band',
        audioUrl: 'https://example.com/audio/starlight-full.mp3',
        createdAt: '2023-02-15T14:30:00Z'
      }
    ],
    currentVersionId: 'v2-song-1',
    metadata: {
      bpm: 72,
      key: 'G Major',
      genre: 'Folk/Indie'
    },
    createdAt: '2023-01-10T10:00:00Z',
    updatedAt: '2023-02-15T14:30:00Z'
  },
  {
    songId: 'song-2',
    title: 'Midnight Drive',
    lyrics: "Verse 1:\nEmpty highways\nCity lights blur by\nRadio playing softly\nUnder a velvet sky\n\nChorus:\nOn a midnight drive\nThoughts running wild and free\nOn a midnight drive\nJust the road and me\n\nVerse 2:\nMemories in the rearview\nFuture up ahead\nSomewhere between yesterday\nAnd tomorrow instead",
    notes: 'Inspired by late night drives through the city. Want to capture that feeling of freedom.',
    inspirations: 'Night drives, city lights, sense of possibility',
    coverArtUrl: 'https://images.unsplash.com/photo-1464851707681-f9d5fdaccea8?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    versions: [
      {
        versionId: 'v1-song-2',
        versionName: 'Piano Demo',
        audioUrl: 'https://example.com/audio/midnight-drive-piano.mp3',
        createdAt: '2023-01-20T11:15:00Z'
      }
    ],
    currentVersionId: 'v1-song-2',
    metadata: {
      bpm: 68,
      key: 'C Minor',
      genre: 'Pop/Alternative'
    },
    createdAt: '2023-01-20T11:15:00Z',
    updatedAt: '2023-01-20T11:15:00Z'
  },
  {
    songId: 'song-3',
    title: 'Dream Catcher',
    lyrics: "Verse 1:\nWeaving threads of silver light\nCatching dreams in the dead of night\nHolding tight to what might be\nIn a world that no one else can see\n\nChorus:\nDream catcher, spinning in the moonlight\nDream catcher, make everything alright\nFilter out the darkness, let in the light\nKeep me safe until morning's in sight",
    notes: 'The bridge needs work. Considering adding a key change for the final chorus.',
    inspirations: 'Native American dream catchers, insomnia, hope',
    coverArtUrl: 'https://images.unsplash.com/photo-1557672172-298e090bd0f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    versions: [
      {
        versionId: 'v1-song-3',
        versionName: 'Rough Demo',
        audioUrl: 'https://example.com/audio/dream-catcher-rough.mp3',
        createdAt: '2023-02-05T16:45:00Z'
      },
      {
        versionId: 'v2-song-3',
        versionName: 'Acoustic Version',
        audioUrl: 'https://example.com/audio/dream-catcher-acoustic.mp3',
        createdAt: '2023-02-10T09:30:00Z'
      },
      {
        versionId: 'v3-song-3',
        versionName: 'Full Production',
        audioUrl: 'https://example.com/audio/dream-catcher-full.mp3',
        createdAt: '2023-02-18T13:20:00Z'
      }
    ],
    currentVersionId: 'v3-song-3',
    metadata: {
      bpm: 76,
      key: 'D Major',
      genre: 'Folk/Pop'
    },
    createdAt: '2023-02-05T16:45:00Z',
    updatedAt: '2023-02-18T13:20:00Z'
  },
  {
    songId: 'song-4',
    title: 'Ocean Waves',
    lyrics: "Verse 1:\nSalt in the air\nSand between my toes\nSun on my skin\nAs the ocean flows\n\nChorus:\nLike ocean waves\nYou crash over me\nLike ocean waves\nYou set me free",
    notes: 'Need to finish second verse and bridge. Thinking about adding some ambient ocean sounds.',
    inspirations: 'Beach vacation, sound of waves, feeling of freedom',
    coverArtUrl: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    versions: [
      {
        versionId: 'v1-song-4',
        versionName: 'Initial Demo',
        audioUrl: 'https://example.com/audio/ocean-waves-demo.mp3',
        createdAt: '2023-03-15T10:30:00Z'
      }
    ],
    currentVersionId: 'v1-song-4',
    metadata: {
      bpm: 82,
      key: 'A Major',
      genre: 'Pop/Summer'
    },
    createdAt: '2023-03-15T10:30:00Z',
    updatedAt: '2023-03-15T10:30:00Z'
  },
  {
    songId: 'song-5',
    title: 'Sunset Boulevard',
    lyrics: "Verse 1:\nCruising down Sunset Boulevard\nWindows down, music loud\nPalm trees swaying in the breeze\nCalifornia summer ease\n\nChorus:\nSunset Boulevard, where dreams are made\nSunset Boulevard, where memories fade\nUnder the California sun\nLiving like we're forever young",
    notes: 'Upbeat summer anthem. Could use some percussion elements like handclaps in the chorus.',
    inspirations: 'Los Angeles, summer road trips, youth',
    coverArtUrl: 'https://images.unsplash.com/photo-1506268452458-bfb3757ed859?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    versions: [
      {
        versionId: 'v1-song-5',
        versionName: 'Guitar Demo',
        audioUrl: 'https://example.com/audio/sunset-guitar.mp3',
        createdAt: '2023-04-01T15:45:00Z'
      },
      {
        versionId: 'v2-song-5',
        versionName: 'Full Band Demo',
        audioUrl: 'https://example.com/audio/sunset-band.mp3',
        createdAt: '2023-04-10T12:15:00Z'
      }
    ],
    currentVersionId: 'v2-song-5',
    metadata: {
      bpm: 118,
      key: 'E Major',
      genre: 'Pop/Rock'
    },
    createdAt: '2023-04-01T15:45:00Z',
    updatedAt: '2023-04-10T12:15:00Z'
  }
];
